var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragVerticallyicon = function SvgDragVerticallyicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.8 10.4a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0ZM8 12a1.6 1.6 0 1 1 0-3.2A1.6 1.6 0 0 1 8 12Zm3.2-1.6a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0-3.2 0ZM3.2 4a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Zm3.2 1.6a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0-3.2 0Zm6.4 1.6a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgDragVerticallyicon;